import { IGetRestaurantsQueryParams } from '@/api/restaurants/get-restaurants-query'

export type ICityUrlParams = Omit<IGetRestaurantsQueryParams, 'tagSlugs' | 'citySlug'> & {
    // tagSlugs should always be appended as an array, for better consistency
    tagSlugs?: Exclude<IGetRestaurantsQueryParams['tagSlugs'], string>
    citySlug: string
}

export type ICityPageParams = Pick<ICityUrlParams, 'citySlug'>
export type ICityPageSearchParams = Omit<ICityUrlParams, 'citySlug'>

export class CityRoute {
    static createUrl(params?: ICityUrlParams) {
        const basePath = '/restaurants'

        if (!params?.citySlug) {
            return basePath
        }

        const cityBasePath = `${basePath}/${params.citySlug}`

        const searchParams = new URLSearchParams()

        if (params.name) searchParams.append(RestaurantsCitySearchUrlParams.SEARCH, params.name)

        // Do not append relevance, as it is the default
        if (params.sortBy && params.sortBy !== DEFAULT_RESTAURANT_SORTING) {
            searchParams.append(RestaurantsCitySearchUrlParams.SORT_BY, params.sortBy)
        }

        if (params.openNow) searchParams.append('openNow', String(true))

        if (params.tagSlugs) {
            if (params.tagSlugs.length > 0) {
                searchParams.append(RestaurantsCitySearchUrlParams.TAGS, params.tagSlugs.join(','))
            }
        }

        const queryString = searchParams.toString()

        return queryString ? `${cityBasePath}?${queryString}` : cityBasePath
    }
}

export enum RestaurantsCitySearchUrlParams {
    CITY_SLUG = 'citySlug',
    SEARCH = 'search',
    TAGS = 'tags',
    PAGE = 'page',
    SORT_BY = 'sortBy',
    OPEN_NOW = 'openNow',
}

export enum RestaurantQuerySorting {
    RECOMMENDED = 'recommended',
    POPULARITY = 'popularity',
    RATING = 'rating',
    DISCOUNT = 'discount',
    NEWEST = 'newest',
    NEAREST = 'nearest',
}

export const DEFAULT_RESTAURANT_SORTING = RestaurantQuerySorting.RECOMMENDED
export const DEFAULT_RESTAURANT_PAGE = 1
